var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"chat chat-empty"},[_c('div',{staticClass:"chat-empty__container"},[_c('font-awesome-icon',{attrs:{"icon":"comment"}}),_c('p',[_vm._v("Выберите чат или "),_c('span',{on:{"click":function($event){return _vm.newChat()}}},[_vm._v("создайте новый")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }